module.exports = __webpack_public_path__ + "assets/img/c9379d8330220a19bc40980c32783be1.png";